module.exports = __webpack_public_path__ + "static/media/language.450e17ad.svg";